<template>
  <div>
    <v-btn v-if="true" icon @click="resetNotifications()">
      <v-badge overlap color="red">
      <span v-if="hasNotification" slot="badge">!</span>
      <v-icon>notifications</v-icon>
      </v-badge>
        </v-btn>

        <v-snackbar v-model="snackbar" top color="error">
            <span>Você tem novas mensagens na Central de Soluções!</span>
            <v-btn flat color="white" @click="snackbar = false"><v-icon>close</v-icon></v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TicketsNotifications',
  data() {
    return {
      snackbar: false,
    };
  },
  computed: {
    ...mapGetters({
      hasNotification: 'tickets/hasNotification',
    }),
  },
  mounted() {
    this.$store.dispatch('tickets/notifications');
  },
  methods: {
    resetNotifications() {
      if (this.hasNotification) {
        this.snackbar = true;
        this.$store.dispatch('tickets/disableTicketNotifications');
      }
    },
  },
};
</script>
